import { getMandant } from '../shared/utils/mandant';
import ScrollToTop from '../shared/utils/ScrollToTop';
import { BehLayout } from '../layout/BehLayout';
import { BehErrorBoundary } from './shared/BehErrorBoundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GuardedRoute from './GuardedRoute';
import AntragsuebersichtPage from './Antragsuebersicht/AntragsuebersichtPage';
import { RoutePaths } from './AppRoutes';
import SchreibtischPage from './Schreibtisch/SchreibtischPage';
import SettingsPage from './Settings/SettingsPage';
import { ConfigAssistantPage } from './ConfigAssistant/ConfigAssistantPage';

export function AppRouter() {
  return (
    <BrowserRouter basename={getMandant()}>
      <ScrollToTop />
      <BehLayout>
        <BehErrorBoundary>
          <Routes>
            <Route element={<GuardedRoute />}>
              <Route
                element={<AntragsuebersichtPage />}
                path={RoutePaths.HOME}
              />
              <Route
                element={<AntragsuebersichtPage />}
                path={RoutePaths.ANTRAEGE}
              />
              <Route
                element={<SchreibtischPage />}
                path={RoutePaths.SCHREIBTISCH}
              />
              <Route
                element={<SchreibtischPage />}
                path={RoutePaths.SCHREIBTISCH_CASE}
              />
              <Route
                element={<SettingsPage />}
                path={RoutePaths.EINSTELLUNGEN}
              />
              <Route
                element={<ConfigAssistantPage />}
                path={RoutePaths.CONFIGASSISTANT}
              />
            </Route>
          </Routes>
        </BehErrorBoundary>
      </BehLayout>
    </BrowserRouter>
  );
}
